import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import ContestUploadFiles from "./ContestUploadFiles";
import { useDispatch } from "react-redux";
import { approveSubmissionContest } from "../../../../../../../redux/contest/action";
import downloadFiles from "../../../../../../Common/FilesRelevent/DownloadFiles";
import { Modal } from "reactstrap";
import LeaveCompanyModel from "../../../../../TeamAndCollaboration/TeamTabs/TeamsModels/LeaveCompanyModel";
import RejectDocumentModel from "./RejectDocumentModel";
import AcceptDocumentModel from "./AcceptDocumentModel";
import CustomReactQuillDescription from "../../../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import ModelGiveReview from "../../../../../../Common/ContractandPost/ModelGiveReview";

export default function MineContestHandover({ pd, posts }) {
  const [worksample, setWork_sample] = useState([]);
  const [modelreject, setModelreject] = useState(false);
  const [modelaccept, setModelaccept] = useState(false);
  const [loading, setLoading] = useState([]);
  const [review, setReview] = useState(false);

  const path = "Assets/scss/searchcontestparticipate.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const dispatch = useDispatch();

  const ApproveSubmission = () => {
    const data = {
      type: "2",
      id: pd?.id,
      status: "15",
    };
    dispatch(approveSubmissionContest(data, setLoading));
  };

  const ReuploadApproveSubmission = () => {
    const data = {
      type: "2",
      id: pd?.id,
      status: "14",
    };
    dispatch(approveSubmissionContest(data, setLoading));
  };


  return (
    <div className ="project-details  entries-lastimg">

      {posts?.status == 13 &&
        <>
          <h4>Review Status</h4>
          {
            pd?.post_rating > 0 ?
              <a >
                Already Reviewed
              </a>
              :
              <a onClick={() => setReview((state) => !state)}>
                Give Review
                <img
                  src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                  alt=""
                />
              </a>
          }
        </>
      }

      {posts?.is_mine == 1 && pd?.status == 13 ? (
        <div className ="tab-sec">
          <div className ="entries">
            <div className ="entries-first">
              <h4>Review the Submitted Documents</h4>
              <div className ="sort-select">
                <button
                  className ="btn"
                  onClick={() => setModelreject(true)}
                >
                  Request changes
                </button>
                <button className ="btn"
                  onClick={() => setModelaccept(true)}
                >
                  Approve Submission
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {pd?.status == 14 && (
        <div className ="tab-sec">
          <div className ="entries">
            <h4>Documents Rejected: Reasons & Required Changes</h4>
            <div className ="entries-third">
              <CustomReactQuillDescription value={pd?.user_message} />
            </div>
          </div>
        </div>
      )}

      {posts?.is_mine == 1 && pd?.status == 12 && (
        <div>
          {posts?.is_mine == 1 ?
            <h1>Waitings for files to Review</h1>
            : ''}
        </div>
      )}

      {(pd?.status == 13 || pd?.status == 15) ? (
        <div className ="tab-sec">
          <div className ="entries">
            <div className ="entries-first">
              <h4>Winner entry files</h4>
            </div>
            <div className ="entries-third">
              <div className ="d-flex justify-content-between attachment-flex">
                <h4>{pd?.handover?.length || 0} Attachments</h4>
                {/* <a><img src={`${CloudStorage.cloudurl}/Assets/Images/handover/download-icon.svg`} alt="" />    Download all   </a> */}
              </div>
              {Array.isArray(pd?.handover) &&
                pd?.handover?.map((item, index) => (
                  <div className ="logo-pdf" key={index}>
                    <div className ="pdf-sec">
                      <a>  <img src={`${CloudStorage.cloudurl}/Assets/Images/handover/file-img.svg`} alt="" />  </a>
                      <div>
                        <h6>File {index + 1}</h6>
                        {/* <p>12.08 MB</p> */}
                      </div>
                    </div>
                    <a>
                      <img onClick={() => downloadFiles(item?.file)} src={`${CloudStorage.cloudurl}/Assets/Images/handover/download-icon.svg`} />
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ) : <></>}

      {(pd?.status == 12 || pd?.status == 13 || pd?.status == 14) && posts?.is_mine != 1 ? (
        <div className ="tab-sec">
          <div className ="entries">
            <h4> Upload Documents <sup>*</sup> <span> (Upload at least 1 file)</span> </h4>
            <div className ="entries-third">

              <ContestUploadFiles
                pd={pd}
                worksample={worksample}
                setWork_sample={setWork_sample}
                posts={posts}
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <Modal className ="popupmodal" isOpen={modelreject}>
        <RejectDocumentModel
          setModelreject={setModelreject}
          pd={pd}
          posts={posts}
        />
      </Modal>

      <Modal className ="popupmodal" isOpen={modelaccept}>
        <AcceptDocumentModel
          setModelaccept={setModelaccept}
          pd={pd}
          posts={posts}
        />
      </Modal>
      <Modal
        size="xl"
        className ="popupmodal rent-modal"
        isOpen={review}
        toggle={() => setReview((state) => !state)}
      >
        <ModelGiveReview
          setReview={setReview}
          proposalmilestones={pd}
          posts={posts}
        />
      </Modal>
    </div>


  );
}
